import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Button } from "antd";

const size = "large";

class FloatingIconButton extends React.Component {
    state = {
        displayMenu: this.props.open
    };
    handleClick = () => {
        this.setState({
            displayMenu: !this.state.displayMenu
        });
    };
    componentWillReceiveProps = () => {
        // if (nextProps.open !== this.props.open)
        this.setState({
            displayMenu: this.props.open
        });
    };
    render() {
        return (
            <div className="pos-fixed r-40px b-40px d-flex align-items-end flex-column z-top">
                {this.state.displayMenu ? this.props.children : null}
                <Button
                    className={cx("scal-15", "box-shade")}
                    type="primary"
                    shape="circle"
                    icon={
                        this.state.displayMenu
                            ? "close"
                            : this.props.icon || "plus"
                    }
                    size={size}
                    onClick={this.handleClick}
                />
            </div>
        );
    }
}

FloatingIconButton.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.object,
    icon: PropTypes.any
};

export default FloatingIconButton;
